import React, { useState } from "react";
import IconButton from "./IconButton";
import HomeIcon from "./Icons/HomeIcon";
import DocumentsIcon from "./Icons/DocumentsIcon";
import DocumentsBigIcon from "./Icons/DocumentsBigIcon";
import ProposalBigIcon from "./Icons/ProposalBigIcon";
import "./Resume.css";

import { 
  UserBooking, 
  SpecificBooking, 
  UserContract, 
  UserData, 
  PostInstallationDocuments,
} from "../../../../types/responseTypes";

import InfoCard3 from "../GreyRectangles/InfoCard3";
import Pending2ndCard from "./Pending2ndCard";
import BaseStatisticsCard from "../GreyRectangles/BaseStatisticsCard";

type TabType = "inicio" | "documentos" ;

interface ResumeBarPending2ndProps {
  userBooking: UserBooking;
  specificBooking: SpecificBooking;
  userData: UserData;
  userContract?: UserContract | null;
  installationDocuments?: PostInstallationDocuments | null;
}

const ResumeBarPending2nd: React.FC<ResumeBarPending2ndProps> = ({
  userBooking, 
  specificBooking, 
  userData, 
  userContract, 
  installationDocuments,
}) => {

  const [activeTab, setActiveTab] = useState<TabType>("inicio");
  const handleSetActiveTab = (tab: TabType) => { setActiveTab(tab) };

  const findDocumentUrl = (where: string, name: string) => {
    // si name no es encontrado, retorna undefined y el boton deja de ser clickeable
    if (where === "installationDocs") {
      return installationDocuments?.installationDocuments.find(doc => doc.name === name)?.url;
    } else if (where === "contract") {
      return userContract?.documents.find(doc => doc.name === name)?.url;
    } 
    return undefined;
  };
  const linkToCompraVenta = findDocumentUrl("contract", "compraventa");
  const linkToPropuesta = `https://ruuf.cl/proposal/booking/${userBooking.bookingId}`

  const openLink = (link: string | undefined) => {
    if (link) {
      const formattedLink = link;//encodeURI(link);
      window.open(formattedLink, "_blank");
    }
  };

  return (
    <div>
      <div className="ResumeBar">
        <IconButton
          label="Inicio"
          icon={<HomeIcon />}
          isActive={activeTab === "inicio"}
          onClick={() => handleSetActiveTab("inicio")}
        />
        <IconButton
          label="Documentos"
          icon={<DocumentsIcon />}
          isActive={activeTab === "documentos"}
          onClick={() => handleSetActiveTab("documentos")}
        />
      </div>

      <div>
        {activeTab === "inicio" && (
          <div className="justify-center">

            <BaseStatisticsCard specificBooking={specificBooking} />

            <Pending2ndCard userData={userData} />

          </div>
        )}

        {activeTab === "documentos" && (
          <div>

            <InfoCard3
              logo={<ProposalBigIcon />}
              title="Propuesta"
              subtitle="Espeando segunda firma"
              buttonText="Revisar"
              onButtonClick={() => openLink(linkToPropuesta)}
            />

            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Compraventa"
              subtitle="Contrato"
              buttonText="Ver"
              onButtonClick={() => openLink(linkToCompraVenta)}
            />

          </div>
        )}
      </div>
    </div>
  );
};

export default ResumeBarPending2nd;
